"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _get = require("../../utils/get");

var _ContextProps = require("../../types/ContextProps");

var _utils = require("../utils");

var IDs = {
  SITE_NAME: 'site.name',
  INDEX_SITE: 'site.index',
  INDEX_PAGE: 'page.index',
  NAME: 'category.name',
  DESCRIPTION: 'category.description',
  IMAGE: 'category.image',
  CATEGORY_PAGE_URL: 'category.url'
};
var userVisible = [];
var _default = {
  IDs: IDs,
  getData: function getData(item) {
    var _ref;

    return _ref = {}, _ref[IDs.SITE_NAME] = (0, _get.get)(item, "context." + _ContextProps.CONTEXT_PROPS.SITE_NAME), _ref[IDs.INDEX_SITE] = (0, _get.getRawValue)(item, "context." + _ContextProps.CONTEXT_PROPS.INDEX_SITE), _ref[IDs.INDEX_PAGE] = (0, _get.getRawValue)(item, "context." + _ContextProps.CONTEXT_PROPS.INDEX_PAGE), _ref[IDs.NAME] = (0, _get.get)(item, 'category.title'), _ref[IDs.DESCRIPTION] = (0, _get.get)(item, 'category.description'), _ref[IDs.IMAGE] = (0, _get.get)(item, 'category.images.0.src'), _ref[IDs.CATEGORY_PAGE_URL] = (0, _get.get)(item, 'category.refersTo'), _ref;
  },
  getLegacySeoBlob: function getLegacySeoBlob() {},
  getBiData: function getBiData() {},
  getKeys: function getKeys() {
    return (0, _utils.getKeys)(IDs, userVisible);
  }
};
exports["default"] = _default;